const contractsHistory = (xmlElement) => {
  const root = xmlElement.getElementsByTagName("cb:ContractsHistory")[0];
  const AggregatedData = root.getElementsByTagName('cb:AggregatedData')[0]

  // start section
  const ContractsNumber = AggregatedData.attributes.ContractsNumber?.value ?? ''
  const ReportingProvidersNumber = AggregatedData.attributes.ReportingProvidersNumber?.value ?? ''
  const TotalCreditLimit = AggregatedData.attributes.TotalCreditLimit?.value ?? ''
  const TotalPotentialExposure = AggregatedData.attributes.TotalPotentialExposure?.value ?? ''
  const TotalDebitBalance = AggregatedData.attributes.TotalDebitBalance?.value ?? ''
  const TotalOverdue = AggregatedData.attributes.TotalOverdue?.value ?? ''
  const Currency = AggregatedData.attributes.Currency?.value ?? ''
  const CurrencyDesc = AggregatedData.attributes.CurrencyDesc?.value ?? ''
  // end section

  const CreditF = () => {
    // start section
    const CreditRoot = root.getElementsByTagName('cb:Credit')[0]
    const NumbersSummary = CreditRoot.getElementsByTagName('cb:NumbersSummary')[0]
    const Requested = NumbersSummary.attributes.Requested?.value ?? ''
    const Active = NumbersSummary.attributes.Active?.value ?? ''
    const Refused = NumbersSummary.attributes.Refused?.value ?? ''
    const Renounced = NumbersSummary.attributes.Renounced?.value ?? ''
    const Closed = NumbersSummary.attributes.Closed?.value ?? ''
    // end section

    // start section
    const AmountsSummary = CreditRoot.getElementsByTagName('cb:AmountsSummary')[0]
    const ContractsCounter = AmountsSummary?.attributes?.ContractsCounter?.value ?? ''
    const CreditLimit = AmountsSummary?.attributes?.CreditLimit?.value ?? ''
    const DebitBalance = AmountsSummary?.attributes?.DebitBalance?.value ?? ''
    const Overdue = AmountsSummary?.attributes?.Overdue?.value ?? ''
    // end section

    // start section
    const NotGranted = Array.from(root.querySelectorAll("Credit > NotGrantedCredit")).map(element => {
      const CBContractCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CBContractCode?.value ?? '';
      const ProviderContractNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderContractNo?.value ?? '';
      const ContractType = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractType?.value ?? '';
      const ContractTypeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractTypeDesc?.value ?? '';
      const ContractPhase = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhase?.value ?? '';
      const ContractPhaseDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhaseDesc?.value ?? '';
      const Role = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.Role?.value ?? '';
      const RoleDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.RoleDesc?.value ?? '';
      const ProviderTypeCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCodeDesc?.value ?? '';
      const ContractRequestDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractRequestDate?.value ?? '';
      const DueDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.DueDate?.value ?? '';
      const CurrencyCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes.CurrencyCode?.value ?? '';
      const CurrencyDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes.CurrencyDesc?.value ?? '';
      const LastUpdateDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes.LastUpdateDate?.value ?? '';
      const ReferenceNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes.ReferenceNo?.value ?? '';
      const ApplicationAmount = element.getElementsByTagName('cb:NotGrantedCredit')[0].attributes.ApplicationAmount?.value ?? '';
      const OriginalAgreementNumber = element.getElementsByTagName('cb:NotGrantedCredit')[0].attributes?.OriginalAgreementNumber?.value ?? '';
      const OriginalAgreementDate = element.getElementsByTagName('cb:NotGrantedCredit')[0].attributes?.OriginalAgreementDate?.value ?? '';
      const CBSubjectCode = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.CBSubjectCode?.value ?? ''
      const Name = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Name?.value ?? ''
      const RoleLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Role?.value ?? ''
      const RoleDescLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.RoleDesc?.value ?? ''

      return {
        CBContractCode,
        ProviderContractNo,
        ContractType,
        ContractTypeDesc,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ContractRequestDate,
        DueDate,
        CurrencyCode,
        CurrencyDesc,
        LastUpdateDate,
        ReferenceNo,
        ApplicationAmount,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        CBSubjectCode,
        Name,
        RoleLinkedSubject,
        RoleDescLinkedSubject,
      }
    })
    // end section

    const Granted = Array.from(root.querySelectorAll('Credit > GrantedCredit')).map(element => {
      // start JoinAccountNumber
      const SubjectSequenceMember = element.getElementsByTagName('cb:JoinAccountNumber')[0].attributes?.SubjectSequenceMember?.value ?? ''
      // end JoinAccountNumber

      // start CommonData
      const ReferenceNo = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceNo?.value ?? ''
      const CBContractCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CBContractCode?.value ?? ''
      const ProviderTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCode?.value ?? ''
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCodeDesc?.value ?? ''
      const ProviderCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCode?.value ?? ''
      const ProviderCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCodeDesc?.value ?? ''
      const ReferenceDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceDate?.value ?? ''
      const ContractPhase = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhase?.value ?? ''
      const ContractPhaseDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhaseDesc?.value ?? ''
      const Role = element.getElementsByTagName('cb:CommonData')[0].attributes?.Role?.value ?? ''
      const RoleDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.RoleDesc?.value ?? ''
      const ContractTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCode?.value ?? ''
      const ContractTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCodeDesc?.value ?? ''
      const StartDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.StartDate?.value ?? ''
      const DueDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.DueDate?.value ?? ''
      const CurrencyCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCode?.value ?? ''
      const CurrencyCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCodeDesc?.value ?? ''
      const PastDueStausCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausCode?.value ?? ''
      const PastDueStausDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausDesc?.value ?? ''
      const ContractStatusCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusCode?.value ?? ''
      const ContractStatusDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDesc?.value ?? ''
      const ContractStatusDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDate?.value ?? ''
      // end CommonData

      // start GrantedCredit
      const CodeCharacteristicCredit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CodeCharacteristicCredit?.value ?? ''
      const CodeCharacteristicCreditDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CodeCharacteristicCreditDesc?.value ?? ''
      const CodeAgreementCredit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CodeAgreementCredit?.value ?? ''
      const CodeAgreementCreditDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CodeAgreementCreditDesc?.value ?? ''
      const OriginalAgreementNumber = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.OriginalAgreementNumber?.value ?? ''
      const OriginalAgreementDate = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.OriginalAgreementDate?.value ?? ''
      const FinalAgreementNumber = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FinalAgreementNumber?.value ?? ''
      const FinalAgreementDate = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FinalAgreementDate?.value ?? ''
      const FrequencyOfCredit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FrequencyOfCredit?.value ?? ''
      const StartDateOfCredit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.StartDateOfCredit?.value ?? ''
      const DebtorCategoryCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.DebtorCategoryCode?.value ?? ''
      const DebtorCategoryCodeDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.DebtorCategoryCodeDesc?.value ?? ''
      const UsageTypeCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.UsageTypeCode?.value ?? ''
      const UsageTypeCodeDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.UsageTypeCodeDesc?.value ?? ''
      const UsageOrientationCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.UsageOrientationCode?.value ?? ''
      const UsageOrientationCodeDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.UsageOrientationCodeDesc?.value ?? ''
      const EconomicSectorCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.EconomicSectorCode?.value ?? ''
      const EconomicSectorCodeDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.EconomicSectorCodeDesc?.value ?? ''
      const CityCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CityCode?.value ?? ''
      const CityCodeDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CityCodeDesc?.value ?? ''
      const ProjectValue = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.ProjectValue?.value ?? ''
      const InterestRate = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.InterestRate?.value ?? ''
      const TypeOfInterestRate = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.TypeOfInterestRate?.value ?? ''
      const TypeOfInterestRateDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.TypeOfInterestRateDesc?.value ?? ''
      const FinancigProgram = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FinancigProgram?.value ?? ''
      const FinancigProgramDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FinancigProgramDesc?.value ?? ''
      const InitialCreditLimit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.InitialCreditLimit?.value ?? ''
      const CreditLimit = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CreditLimit?.value ?? ''
      const CurrentMonthRealization = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.CurrentMonthRealization?.value ?? ''
      const Penalty = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.Penalty?.value ?? ''
      const DebitBalance = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.DebitBalance?.value ?? ''
      const ValueInOriginalCurrency = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.ValueInOriginalCurrency?.value ?? ''
      const PrincipalOverdueAmount = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.PrincipalOverdueAmount?.value ?? ''
      const InterestOverdueAmount = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.InterestOverdueAmount?.value ?? ''
      const DaysPastDue = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.DaysPastDue?.value ?? ''
      const OverduePaymentsNumber = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.OverduePaymentsNumber?.value ?? ''
      const FrequencyOfRestructuring = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.FrequencyOfRestructuring?.value ?? ''
      const BadCreditDate = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.BadCreditDate?.value ?? ''
      const BadCreditCauseCode = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.BadCreditCauseCode?.value ?? ''
      const BadCreditCauseDesc = element.getElementsByTagName('cb:GrantedCredit')[0].attributes?.BadCreditCauseDesc?.value ?? ''
      // end GrantedCredit

      // Collaterals
      const Collaterals = element.getElementsByTagName('cb:Collaterals')[0]
      const CollateralsCounter = Collaterals.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.CollateralsCounter?.value ?? ''
      const TotalCollateralValue = Collaterals.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.TotalCollateralValue?.value ?? ''
      const GrantedCollaterals = Array.from(Collaterals.getElementsByTagName('cb:GrantedCollaterals')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.ReferenceDate?.value ?? ''
        const Information = subElement.getElementsByTagName('cb:AttributeData')[0]?.attributes?.Information?.value ?? ''
        // end AttributeData

        // GrantedCollateral
        const CollateralNumber = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralNumber?.value ?? ''
        const CollateralStatusCode = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralStatusCode?.value ?? ''
        const CollateralStatusDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralStatusDesc?.value ?? ''
        const CollateralTypeCode = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralTypeCode?.value ?? ''
        const CollateralTypeDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralTypeDesc?.value ?? ''
        const CollateralRating = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralRating?.value ?? ''
        const RatingInstitutionCode = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.RatingInstitutionCode?.value ?? ''
        const RatingInstitutionDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.RatingInstitutionDesc?.value ?? ''
        const BindTypeCode = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.BindTypeCode?.value ?? ''
        const BindTypeDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.BindTypeDesc?.value ?? ''
        const BindDate = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.BindDate?.value ?? ''
        const CollateralOwnerName = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralOwnerName?.value ?? ''
        const ProofOfOwnership = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.ProofOfOwnership?.value ?? ''
        const CollateralValueNJOP = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralValueNJOP?.value ?? ''
        const CollateralValueReporter = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralValueReporter?.value ?? ''
        const CollateralAssessmentDateReporter = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralAssessmentDateReporter?.value ?? ''
        const CollateralValueIndependentAssessors = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralValueIndependentAssessors?.value ?? ''
        const IndependentAssessorsName = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.IndependentAssessorsName?.value ?? ''
        const CollateralAssessmentDateAssessors = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CollateralAssessmentDateAssessors?.value ?? ''
        const CommonCollateralStatus = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CommonCollateralStatus?.value ?? ''
        const CommonCollateralStatusDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CommonCollateralStatusDesc?.value ?? ''
        const CommonCollateralPercentage = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.CommonCollateralPercentage?.value ?? ''
        const JointAccountCreditStatus = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.JointAccountCreditStatus?.value ?? ''
        const JointAccountCreditStatusDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.JointAccountCreditStatusDesc?.value ?? ''
        const InsuredDesc = subElement.getElementsByTagName('cb:GrantedCollateral')[0]?.attributes?.InsuredDesc?.value ?? ''
        // end GrantedCollateral

        // CollateralAddress
        const CollateralAddress = subElement.getElementsByTagName('cb:CollateralAddress')[0]
        const Address = CollateralAddress.getElementsByTagName('cb:Address')[0]?.attributes?.Address?.value ?? ''
        const City = CollateralAddress.getElementsByTagName('cb:Address')[0]?.attributes?.City?.value ?? ''
        const CityDesc = CollateralAddress.getElementsByTagName('cb:AddressDesc')[0]?.attributes?.CityDesc?.value ?? ''
        // end CollateralAddress

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          Information,
          CollateralNumber,
          CollateralStatusCode,
          CollateralStatusDesc,
          CollateralTypeCode,
          CollateralTypeDesc,
          CollateralRating,
          RatingInstitutionCode,
          RatingInstitutionDesc,
          BindTypeCode,
          BindTypeDesc,
          BindDate,
          CollateralOwnerName,
          ProofOfOwnership,
          CollateralValueNJOP,
          CollateralValueReporter,
          CollateralAssessmentDateReporter,
          CollateralValueIndependentAssessors,
          IndependentAssessorsName,
          CollateralAssessmentDateAssessors,
          CommonCollateralStatus,
          CommonCollateralStatusDesc,
          CommonCollateralPercentage,
          JointAccountCreditStatus,
          JointAccountCreditStatusDesc,
          InsuredDesc,
          Address,
          City,
          CityDesc,
        }
      })
      // End Collaterals

      // Guarantors
      const Guarantors = element.getElementsByTagName('cb:Guarantors')[0];
      const GuarantorsCounter = Guarantors.getElementsByTagName('cb:GuarantorsSummary')[0].attributes?.GuarantorsCounter?.value ?? ''
      const GuarantorsData = Array.from(Guarantors.getElementsByTagName('cb:GuarantorsData')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ReferenceDate?.value ?? ''
        // end AttributeData

        // GrantedGuarantor
        const GuarantorNameAsID = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorNameAsID?.value ?? ''
        const GuarantorFullName = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorFullName?.value ?? ''
        const GuarantorTypeCode = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeCode?.value ?? ''
        const GuarantorTypeDesc = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeDesc?.value ?? ''
        const PercentageGuaranteed = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.PercentageGuaranteed?.value ?? ''
        // end GrantedGuarantor

        // GuarantorAddress
        const Address = subElement.getElementsByTagName('cb:GuarantorAddress')[0].attributes.Address?.value ?? ''
        // end GuarantorAddress

        // GuarantorIdentity
        const IdentityType = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityType?.value ?? ''
        const IdentityNumber = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityNumber?.value ?? ''
        const IdentityTypeDesc = subElement.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes.IdentityTypeDesc?.value ?? ''
        // end GuarantorIdentity

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          GuarantorNameAsID,
          GuarantorFullName,
          GuarantorTypeCode,
          GuarantorTypeDesc,
          PercentageGuaranteed,
          Address,
          IdentityType,
          IdentityNumber,
          IdentityTypeDesc,
        }
      })
      // end Guarantors

      // Maximum
      const MaxOverduePaymentsAmount = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsAmount?.value ?? ''
      const MaxOverduePaymentsNumber = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsNumber?.value ?? ''
      const MaxDaysPastDue = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxDaysPastDue?.value ?? ''
      const WorstStatusCode = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusCode?.value ?? ''
      const WorstStatusDesc = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDesc?.value ?? ''
      const WorstStatusDate = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDate?.value ?? ''
      // end Maximum

      // list profile
      const listProfileArr = Array.from(element.getElementsByTagName('cb:CreditProfile')).map(subElement => {
        const ReferenceYear = subElement.attributes.ReferenceYear?.value ?? '';
        const ReferenceMonth = subElement.attributes.ReferenceMonth?.value ?? '';
        const DaysPastDue = subElement.attributes.DaysPastDue?.value ?? '';
        const Overdue = subElement.attributes.Overdue?.value ?? '';
        const OverduePaymentsNumber = subElement.attributes.OverduePaymentsNumber?.value ?? '';
        const QualityCode = subElement.attributes.QualityCode?.value ?? '';
        const QualityCodeDesc = subElement.attributes.QualityCodeDesc?.value ?? '';
        const BadCreditCauseCode = subElement.attributes.BadCreditCauseCode?.value ?? '';
        const BadCreditCauseDesc = subElement.attributes.BadCreditCauseDesc?.value ?? '';
        const DebitBalance = subElement.attributes.DebitBalance?.value ?? '';
        const CurrentMonthRealization = subElement.attributes.CurrentMonthRealization?.value ?? '';
        const ContractStatusCode = subElement.attributes.ContractStatusCode?.value ?? '';
        const ContractStatusDesc = subElement.attributes.ContractStatusDesc?.value ?? '';

        return { ReferenceYear, ReferenceMonth, DaysPastDue, Overdue, OverduePaymentsNumber, QualityCode, QualityCodeDesc, BadCreditCauseCode, BadCreditCauseDesc, DebitBalance, CurrentMonthRealization, ContractStatusCode, ContractStatusDesc }
      })
      let listProfile = [{ JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: null }];
      let tahun = null;
      const arrReverse = listProfileArr.reverse();
      // console.log(arrReverse);
      arrReverse.forEach(e => {
        if (tahun !== null && tahun !== e.ReferenceYear) {
          listProfile = [...listProfile, { JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: e.ReferenceYear }]

          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        } else {
          listProfile[listProfile.length - 1].YEAR = e.ReferenceYear
          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        }

        tahun = e.ReferenceYear;

      })
      // end list profile 
      return {
        SubjectSequenceMember,
        ReferenceNo,
        CBContractCode,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ReferenceDate,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ContractTypeCode,
        ContractTypeCodeDesc,
        StartDate,
        DueDate,
        CurrencyCode,
        CurrencyCodeDesc,
        PastDueStausCode,
        PastDueStausDesc,
        ContractStatusCode,
        ContractStatusDesc,
        ContractStatusDate,
        CodeCharacteristicCredit,
        CodeCharacteristicCreditDesc,
        CodeAgreementCredit,
        CodeAgreementCreditDesc,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        FinalAgreementNumber,
        FinalAgreementDate,
        FrequencyOfCredit,
        StartDateOfCredit,
        DebtorCategoryCode,
        DebtorCategoryCodeDesc,
        UsageTypeCode,
        UsageTypeCodeDesc,
        UsageOrientationCode,
        UsageOrientationCodeDesc,
        EconomicSectorCode,
        EconomicSectorCodeDesc,
        CityCode,
        CityCodeDesc,
        ProjectValue,
        InterestRate,
        TypeOfInterestRate,
        TypeOfInterestRateDesc,
        FinancigProgram,
        FinancigProgramDesc,
        InitialCreditLimit,
        CreditLimit,
        CurrentMonthRealization,
        Penalty,
        DebitBalance,
        ValueInOriginalCurrency,
        PrincipalOverdueAmount,
        InterestOverdueAmount,
        DaysPastDue,
        OverduePaymentsNumber,
        FrequencyOfRestructuring,
        BadCreditDate,
        BadCreditCauseCode,
        BadCreditCauseDesc,
        CollateralsCounter,
        TotalCollateralValue,
        GuarantorsCounter,
        GrantedCollaterals,
        GuarantorsData,
        MaxOverduePaymentsAmount,
        MaxOverduePaymentsNumber,
        MaxDaysPastDue,
        WorstStatusCode,
        WorstStatusDesc,
        WorstStatusDate,
        listProfile,
        listProfileArr: listProfileArr.reverse(),
      }
    })

    const result = {
      Name: "CREDIT / FINANCING",
      Requested,
      Active,
      Refused,
      Renounced,
      Closed,
      ContractsCounter,
      CreditLimit,
      DebitBalance,
      Overdue,
      NotGranted,
      Granted,
    }

    return result
  }

  const BondF = () => {
    // start section
    const BondRoot = root.getElementsByTagName('cb:Bond')[0]
    const NumbersSummary = BondRoot.getElementsByTagName('cb:NumbersSummary')[0]
    const Requested = NumbersSummary.attributes.Requested?.value ?? ''
    const Active = NumbersSummary.attributes.Active?.value ?? ''
    const Refused = NumbersSummary.attributes.Refused?.value ?? ''
    const Renounced = NumbersSummary.attributes.Renounced?.value ?? ''
    const Closed = NumbersSummary.attributes.Closed?.value ?? ''
    // end section

    // start section
    const AmountsSummary = BondRoot.getElementsByTagName('cb:AmountsSummary')[0]
    const ContractsCounter = AmountsSummary?.attributes?.ContractsCounter?.value ?? ''
    const CreditLimit = AmountsSummary?.attributes?.CreditLimit?.value ?? ''
    const DebitBalance = AmountsSummary?.attributes?.DebitBalance?.value ?? ''
    const Overdue = AmountsSummary?.attributes?.Overdue?.value ?? ''
    // end section

    // start section
    const NotGranted = Array.from(root.querySelectorAll("Bond > NotGrantedBond")).map(element => {
      const CBContractCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CBContractCode?.value ?? '';
      const ProviderContractNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderContractNo?.value ?? '';
      const ContractType = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractType?.value ?? '';
      const ContractTypeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractTypeDesc?.value ?? '';
      const ContractPhase = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhase?.value ?? '';
      const ContractPhaseDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhaseDesc?.value ?? '';
      const Role = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.Role?.value ?? '';
      const RoleDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.RoleDesc?.value ?? '';
      const ProviderTypeCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCodeDesc?.value ?? '';
      const ContractRequestDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractRequestDate?.value ?? '';
      const DueDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.DueDate?.value ?? '';
      const CurrencyCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyCode?.value ?? '';
      const CurrencyDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyDesc?.value ?? '';
      const LastUpdateDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.LastUpdateDate?.value ?? '';
      const ReferenceNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ReferenceNo?.value ?? '';
      const ApplicationAmount = element.getElementsByTagName('cb:NotGrantedBond')[0].attributes?.ApplicationAmount?.value ?? '';
      const OriginalAgreementNumber = element.getElementsByTagName('cb:NotGrantedBond')[0].attributes?.OriginalAgreementNumber?.value ?? '';
      const OriginalAgreementDate = element.getElementsByTagName('cb:NotGrantedBond')[0].attributes?.OriginalAgreementDate?.value ?? '';
      const CBSubjectCode = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.CBSubjectCode?.value ?? ''
      const Name = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Name?.value ?? ''
      const RoleLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Role?.value ?? ''
      const RoleDescLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.RoleDesc?.value ?? ''

      return {
        CBContractCode,
        ProviderContractNo,
        ContractType,
        ContractTypeDesc,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ContractRequestDate,
        DueDate,
        CurrencyCode,
        CurrencyDesc,
        LastUpdateDate,
        ReferenceNo,
        ApplicationAmount,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        CBSubjectCode,
        Name,
        RoleLinkedSubject,
        RoleDescLinkedSubject,
      }
    })
    // end section

    const Granted = Array.from(root.querySelectorAll('Bond > GrantedBond')).map(element => {

      // start CommonData
      const ReferenceNo = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceNo?.value ?? ''
      const CBContractCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CBContractCode?.value ?? ''
      const ProviderTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCode?.value ?? ''
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCodeDesc?.value ?? ''
      const ProviderCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCode?.value ?? ''
      const ProviderCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCodeDesc?.value ?? ''
      const ReferenceDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceDate?.value ?? ''
      const ContractPhase = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhase?.value ?? ''
      const ContractPhaseDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhaseDesc?.value ?? ''
      const Role = element.getElementsByTagName('cb:CommonData')[0].attributes?.Role?.value ?? ''
      const RoleDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.RoleDesc?.value ?? ''
      const ContractTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCode?.value ?? ''
      const ContractTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCodeDesc?.value ?? ''
      const StartDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.StartDate?.value ?? ''
      const DueDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.DueDate?.value ?? ''
      const CurrencyCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCode?.value ?? ''
      const CurrencyCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCodeDesc?.value ?? ''
      const PastDueStausCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausCode?.value ?? ''
      const PastDueStausDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausDesc?.value ?? ''
      const ContractStatusCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusCode?.value ?? ''
      const ContractStatusDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDesc?.value ?? ''
      const ContractStatusDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDate?.value ?? ''
      // end CommonData

      // start GrantedBond
      const CodeCharacteristicCredit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CodeCharacteristicCredit?.value ?? ''
      const CodeCharacteristicCreditDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CodeCharacteristicCreditDesc?.value ?? ''
      const CodeAgreementCredit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CodeAgreementCredit?.value ?? ''
      const CodeAgreementCreditDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CodeAgreementCreditDesc?.value ?? ''
      const OriginalAgreementNumber = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.OriginalAgreementNumber?.value ?? ''
      const OriginalAgreementDate = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.OriginalAgreementDate?.value ?? ''
      const FinalAgreementNumber = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FinalAgreementNumber?.value ?? ''
      const FinalAgreementDate = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FinalAgreementDate?.value ?? ''
      const FrequencyOfCredit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FrequencyOfCredit?.value ?? ''
      const StartDateOfCredit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.StartDateOfCredit?.value ?? ''
      const DebtorCategoryCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.DebtorCategoryCode?.value ?? ''
      const DebtorCategoryCodeDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.DebtorCategoryCodeDesc?.value ?? ''
      const UsageTypeCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.UsageTypeCode?.value ?? ''
      const UsageTypeCodeDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.UsageTypeCodeDesc?.value ?? ''
      const UsageOrientationCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.UsageOrientationCode?.value ?? ''
      const UsageOrientationCodeDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.UsageOrientationCodeDesc?.value ?? ''
      const EconomicSectorCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.EconomicSectorCode?.value ?? ''
      const EconomicSectorCodeDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.EconomicSectorCodeDesc?.value ?? ''
      const CityCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CityCode?.value ?? ''
      const CityCodeDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CityCodeDesc?.value ?? ''
      const ProjectValue = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.ProjectValue?.value ?? ''
      const InterestRate = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.InterestRate?.value ?? ''
      const TypeOfInterestRate = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.TypeOfInterestRate?.value ?? ''
      const TypeOfInterestRateDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.TypeOfInterestRateDesc?.value ?? ''
      const FinancigProgram = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FinancigProgram?.value ?? ''
      const FinancigProgramDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FinancigProgramDesc?.value ?? ''
      const InitialCreditLimit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.InitialCreditLimit?.value ?? ''
      const CreditLimit = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CreditLimit?.value ?? ''
      const CurrentMonthRealization = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.CurrentMonthRealization?.value ?? ''
      const Penalty = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.Penalty?.value ?? ''
      const DebitBalance = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.DebitBalance?.value ?? ''
      const ValueInOriginalCurrency = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.ValueInOriginalCurrency?.value ?? ''
      const PrincipalOverdueAmount = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.PrincipalOverdueAmount?.value ?? ''
      const InterestOverdueAmount = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.InterestOverdueAmount?.value ?? ''
      const DaysPastDue = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.DaysPastDue?.value ?? ''
      const OverduePaymentsNumber = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.OverduePaymentsNumber?.value ?? ''
      const FrequencyOfRestructuring = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.FrequencyOfRestructuring?.value ?? ''
      const BadCreditDate = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.BadCreditDate?.value ?? ''
      const BadCreditCauseCode = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.BadCreditCauseCode?.value ?? ''
      const BadCreditCauseDesc = element.getElementsByTagName('cb:GrantedBond')[0].attributes?.BadCreditCauseDesc?.value ?? ''
      // end GrantedBond

      // Collaterals
      const CollateralsCounter = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.CollateralsCounter?.value ?? ''
      const TotalCollateralValue = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.TotalCollateralValue?.value ?? ''
      // End Collaterals

      // Guarantors
      const GuarantorsCounter = element.getElementsByTagName('cb:GuarantorsSummary')[0].attributes?.GuarantorsCounter?.value ?? ''
      const GuarantorsData = Array.from(element.getElementsByTagName('cb:GuarantorsData')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ReferenceDate?.value ?? ''
        // end AttributeData

        // GrantedGuarantor
        const GuarantorNameAsID = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorNameAsID?.value ?? ''
        const GuarantorFullName = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorFullName?.value ?? ''
        const GuarantorTypeCode = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeCode?.value ?? ''
        const GuarantorTypeDesc = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeDesc?.value ?? ''
        const PercentageGuaranteed = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.PercentageGuaranteed?.value ?? ''
        // end GrantedGuarantor

        // GuarantorAddress
        const Address = subElement.getElementsByTagName('cb:GuarantorAddress')[0].attributes.Address?.value ?? ''
        // end GuarantorAddress

        // GuarantorIdentity
        const IdentityType = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityType?.value ?? ''
        const IdentityNumber = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityNumber?.value ?? ''
        const IdentityTypeDesc = subElement.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes.IdentityTypeDesc?.value ?? ''
        // end GuarantorIdentity

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          GuarantorNameAsID,
          GuarantorFullName,
          GuarantorTypeCode,
          GuarantorTypeDesc,
          PercentageGuaranteed,
          Address,
          IdentityType,
          IdentityNumber,
          IdentityTypeDesc,
        }
      })
      // end Guarantors

      // Maximum
      const MaxOverduePaymentsAmount = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsAmount?.value ?? ''
      const MaxOverduePaymentsNumber = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsNumber?.value ?? ''
      const MaxDaysPastDue = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxDaysPastDue?.value ?? ''
      const WorstStatusCode = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusCode?.value ?? ''
      const WorstStatusDesc = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDesc?.value ?? ''
      const WorstStatusDate = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDate?.value ?? ''
      // end Maximum

      // list profile
      const listProfileArr = Array.from(element.getElementsByTagName('cb:BondProfile')).map(subElement => {
        const ReferenceYear = subElement.attributes.ReferenceYear?.value ?? '';
        const ReferenceMonth = subElement.attributes.ReferenceMonth?.value ?? '';
        const DaysPastDue = subElement.attributes.DaysPastDue?.value ?? '';
        const Overdue = subElement.attributes.Overdue?.value ?? '';
        const OverduePaymentsNumber = subElement.attributes.OverduePaymentsNumber?.value ?? '';
        const QualityCode = subElement.attributes.QualityCode?.value ?? '';
        const QualityCodeDesc = subElement.attributes.QualityCodeDesc?.value ?? '';
        const BadCreditCauseCode = subElement.attributes.BadCreditCauseCode?.value ?? '';
        const BadCreditCauseDesc = subElement.attributes.BadCreditCauseDesc?.value ?? '';
        const DebitBalance = subElement.attributes.DebitBalance?.value ?? '';
        const CurrentMonthRealization = subElement.attributes.CurrentMonthRealization?.value ?? '';
        const ContractStatusCode = subElement.attributes.ContractStatusCode?.value ?? '';
        const ContractStatusDesc = subElement.attributes.ContractStatusDesc?.value ?? '';

        return { ReferenceYear, ReferenceMonth, DaysPastDue, Overdue, OverduePaymentsNumber, QualityCode, QualityCodeDesc, BadCreditCauseCode, BadCreditCauseDesc, DebitBalance, CurrentMonthRealization, ContractStatusCode, ContractStatusDesc }
      })
      let listProfile = [{ JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: null }];
      let tahun = null;
      const arrReverse = listProfileArr.reverse();
      console.log(arrReverse);
      arrReverse.forEach(e => {
        if (tahun !== null && tahun !== e.ReferenceYear) {
          listProfile = [...listProfile, { JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: e.ReferenceYear }]

          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        } else {
          listProfile[listProfile.length - 1].YEAR = e.ReferenceYear
          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        }

        tahun = e.ReferenceYear;

      })
      // end list profile 

      return {
        ReferenceNo,
        CBContractCode,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ReferenceDate,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ContractTypeCode,
        ContractTypeCodeDesc,
        StartDate,
        DueDate,
        CurrencyCode,
        CurrencyCodeDesc,
        PastDueStausCode,
        PastDueStausDesc,
        ContractStatusCode,
        ContractStatusDesc,
        ContractStatusDate,
        CodeCharacteristicCredit,
        CodeCharacteristicCreditDesc,
        CodeAgreementCredit,
        CodeAgreementCreditDesc,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        FinalAgreementNumber,
        FinalAgreementDate,
        FrequencyOfCredit,
        StartDateOfCredit,
        DebtorCategoryCode,
        DebtorCategoryCodeDesc,
        UsageTypeCode,
        UsageTypeCodeDesc,
        UsageOrientationCode,
        UsageOrientationCodeDesc,
        EconomicSectorCode,
        EconomicSectorCodeDesc,
        CityCode,
        CityCodeDesc,
        ProjectValue,
        InterestRate,
        TypeOfInterestRate,
        TypeOfInterestRateDesc,
        FinancigProgram,
        FinancigProgramDesc,
        InitialCreditLimit,
        CreditLimit,
        CurrentMonthRealization,
        Penalty,
        DebitBalance,
        ValueInOriginalCurrency,
        PrincipalOverdueAmount,
        InterestOverdueAmount,
        DaysPastDue,
        OverduePaymentsNumber,
        FrequencyOfRestructuring,
        BadCreditDate,
        BadCreditCauseCode,
        BadCreditCauseDesc,
        CollateralsCounter,
        TotalCollateralValue,
        GuarantorsCounter,
        GuarantorsData,
        MaxOverduePaymentsAmount,
        MaxOverduePaymentsNumber,
        MaxDaysPastDue,
        WorstStatusCode,
        WorstStatusDesc,
        WorstStatusDate,
        listProfile,
        listProfileArr: listProfileArr.reverse(),
      }
    })

    const result = {
      Name: "BOND / SECURITIES",
      Requested,
      Active,
      Refused,
      Renounced,
      Closed,
      ContractsCounter,
      CreditLimit,
      DebitBalance,
      Overdue,
      NotGranted,
      Granted,
    }

    return result
  }

  const LetterOfCreditF = () => {
    // start section
    const LetterOfCreditRoot = root.getElementsByTagName('cb:LetterOfCredit')[0]
    const NumbersSummary = LetterOfCreditRoot.getElementsByTagName('cb:NumbersSummary')[0]
    const Requested = NumbersSummary.attributes.Requested?.value ?? ''
    const Active = NumbersSummary.attributes.Active?.value ?? ''
    const Refused = NumbersSummary.attributes.Refused?.value ?? ''
    const Renounced = NumbersSummary.attributes.Renounced?.value ?? ''
    const Closed = NumbersSummary.attributes.Closed?.value ?? ''
    // end section

    // start section
    const AmountsSummary = LetterOfCreditRoot.getElementsByTagName('cb:AmountsSummary')[0]
    const ContractsCounter = AmountsSummary?.attributes?.ContractsCounter?.value ?? ''
    const CreditLimit = AmountsSummary?.attributes?.CreditLimit?.value ?? ''
    const DebitBalance = AmountsSummary?.attributes?.DebitBalance?.value ?? ''
    const Overdue = AmountsSummary?.attributes?.Overdue?.value ?? ''
    // end section

    // start section
    const NotGranted = Array.from(root.querySelectorAll("LetterOfCredit > NotGrantedCredit")).map(element => {
      const CBContractCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CBContractCode?.value ?? '';
      const ProviderContractNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderContractNo?.value ?? '';
      const ContractType = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractType?.value ?? '';
      const ContractTypeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractTypeDesc?.value ?? '';
      const ContractPhase = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhase?.value ?? '';
      const ContractPhaseDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhaseDesc?.value ?? '';
      const Role = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.Role?.value ?? '';
      const RoleDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.RoleDesc?.value ?? '';
      const ProviderTypeCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCodeDesc?.value ?? '';
      const ContractRequestDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractRequestDate?.value ?? '';
      const DueDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.DueDate?.value ?? '';
      const CurrencyCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyCode.value ?? '';
      const CurrencyDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyDesc.value ?? '';
      const LastUpdateDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.LastUpdateDate.value ?? '';
      const ReferenceNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ReferenceNo.value ?? '';
      const ApplicationAmount = element.getElementsByTagName('cb:NotGrantedLetterOfCredit')[0].attributes?.ApplicationAmount.value ?? '';
      const OriginalAgreementNumber = element.getElementsByTagName('cb:NotGrantedLetterOfCredit')[0].attributes?.OriginalAgreementNumber?.value ?? '';
      const OriginalAgreementDate = element.getElementsByTagName('cb:NotGrantedLetterOfCredit')[0].attributes?.OriginalAgreementDate?.value ?? '';
      const CBSubjectCode = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.CBSubjectCode?.value ?? ''
      const Name = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Name?.value ?? ''
      const RoleLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Role?.value ?? ''
      const RoleDescLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.RoleDesc?.value ?? ''

      return {
        CBContractCode,
        ProviderContractNo,
        ContractType,
        ContractTypeDesc,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ContractRequestDate,
        DueDate,
        CurrencyCode,
        CurrencyDesc,
        LastUpdateDate,
        ReferenceNo,
        ApplicationAmount,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        CBSubjectCode,
        Name,
        RoleLinkedSubject,
        RoleDescLinkedSubject,
      }
    })
    // end section

    const Granted = Array.from(root.querySelectorAll('LetterOfCredit > GrantedLetterOfCredit')).map(element => {

      // start CommonData
      const ReferenceNo = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceNo?.value ?? ''
      const CBContractCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CBContractCode?.value ?? ''
      const ProviderTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCode?.value ?? ''
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCodeDesc?.value ?? ''
      const ProviderCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCode?.value ?? ''
      const ProviderCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCodeDesc?.value ?? ''
      const ReferenceDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceDate?.value ?? ''
      const ContractPhase = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhase?.value ?? ''
      const ContractPhaseDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhaseDesc?.value ?? ''
      const Role = element.getElementsByTagName('cb:CommonData')[0].attributes?.Role?.value ?? ''
      const RoleDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.RoleDesc?.value ?? ''
      const ContractTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCode?.value ?? ''
      const ContractTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCodeDesc?.value ?? ''
      const StartDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.StartDate?.value ?? ''
      const DueDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.DueDate?.value ?? ''
      const CurrencyCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCode?.value ?? ''
      const CurrencyCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCodeDesc?.value ?? ''
      const PastDueStausCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausCode?.value ?? ''
      const PastDueStausDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausDesc?.value ?? ''
      const ContractStatusCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusCode?.value ?? ''
      const ContractStatusDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDesc?.value ?? ''
      const ContractStatusDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDate?.value ?? ''
      // end CommonData

      // start GrantedLetterOfCredit
      const CodeCharacteristicCredit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CodeCharacteristicCredit?.value ?? ''
      const CodeCharacteristicCreditDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CodeCharacteristicCreditDesc?.value ?? ''
      const CodeAgreementCredit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CodeAgreementCredit?.value ?? ''
      const CodeAgreementCreditDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CodeAgreementCreditDesc?.value ?? ''
      const OriginalAgreementNumber = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.OriginalAgreementNumber?.value ?? ''
      const OriginalAgreementDate = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.OriginalAgreementDate?.value ?? ''
      const FinalAgreementNumber = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FinalAgreementNumber?.value ?? ''
      const FinalAgreementDate = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FinalAgreementDate?.value ?? ''
      const FrequencyOfCredit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FrequencyOfCredit?.value ?? ''
      const StartDateOfCredit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.StartDateOfCredit?.value ?? ''
      const DebtorCategoryCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.DebtorCategoryCode?.value ?? ''
      const DebtorCategoryCodeDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.DebtorCategoryCodeDesc?.value ?? ''
      const UsageTypeCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.UsageTypeCode?.value ?? ''
      const UsageTypeCodeDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.UsageTypeCodeDesc?.value ?? ''
      const UsageOrientationCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.UsageOrientationCode?.value ?? ''
      const UsageOrientationCodeDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.UsageOrientationCodeDesc?.value ?? ''
      const EconomicSectorCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.EconomicSectorCode?.value ?? ''
      const EconomicSectorCodeDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.EconomicSectorCodeDesc?.value ?? ''
      const CityCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CityCode?.value ?? ''
      const CityCodeDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CityCodeDesc?.value ?? ''
      const ProjectValue = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.ProjectValue?.value ?? ''
      const InterestRate = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.InterestRate?.value ?? ''
      const TypeOfInterestRate = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.TypeOfInterestRate?.value ?? ''
      const TypeOfInterestRateDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.TypeOfInterestRateDesc?.value ?? ''
      const FinancigProgram = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FinancigProgram?.value ?? ''
      const FinancigProgramDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FinancigProgramDesc?.value ?? ''
      const InitialCreditLimit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.InitialCreditLimit?.value ?? ''
      const CreditLimit = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CreditLimit?.value ?? ''
      const CurrentMonthRealization = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.CurrentMonthRealization?.value ?? ''
      const Penalty = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.Penalty?.value ?? ''
      const DebitBalance = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.DebitBalance?.value ?? ''
      const ValueInOriginalCurrency = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.ValueInOriginalCurrency?.value ?? ''
      const PrincipalOverdueAmount = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.PrincipalOverdueAmount?.value ?? ''
      const InterestOverdueAmount = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.InterestOverdueAmount?.value ?? ''
      const DaysPastDue = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.DaysPastDue?.value ?? ''
      const OverduePaymentsNumber = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.OverduePaymentsNumber?.value ?? ''
      const FrequencyOfRestructuring = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.FrequencyOfRestructuring?.value ?? ''
      const BadCreditDate = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.BadCreditDate?.value ?? ''
      const BadCreditCauseCode = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.BadCreditCauseCode?.value ?? ''
      const BadCreditCauseDesc = element.getElementsByTagName('cb:GrantedLetterOfCredit')[0].attributes?.BadCreditCauseDesc?.value ?? ''
      // end GrantedLetterOfCredit

      // Collaterals
      const CollateralsCounter = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.CollateralsCounter?.value ?? ''
      const TotalCollateralValue = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.TotalCollateralValue?.value ?? ''
      // End Collaterals

      // Guarantors
      const GuarantorsCounter = element.getElementsByTagName('cb:GuarantorsSummary')[0].attributes?.GuarantorsCounter?.value ?? ''
      const GuarantorsData = Array.from(element.getElementsByTagName('cb:GuarantorsData')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ReferenceDate?.value ?? ''
        // end AttributeData

        // GrantedGuarantor
        const GuarantorNameAsID = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorNameAsID?.value ?? ''
        const GuarantorFullName = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorFullName?.value ?? ''
        const GuarantorTypeCode = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeCode?.value ?? ''
        const GuarantorTypeDesc = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeDesc?.value ?? ''
        const PercentageGuaranteed = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.PercentageGuaranteed?.value ?? ''
        // end GrantedGuarantor

        // GuarantorAddress
        const Address = subElement.getElementsByTagName('cb:GuarantorAddress')[0].attributes.Address?.value ?? ''
        // end GuarantorAddress

        // GuarantorIdentity
        const IdentityType = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityType?.value ?? ''
        const IdentityNumber = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityNumber?.value ?? ''
        const IdentityTypeDesc = subElement.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes.IdentityTypeDesc?.value ?? ''
        // end GuarantorIdentity

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          GuarantorNameAsID,
          GuarantorFullName,
          GuarantorTypeCode,
          GuarantorTypeDesc,
          PercentageGuaranteed,
          Address,
          IdentityType,
          IdentityNumber,
          IdentityTypeDesc,
        }
      })
      // end Guarantors

      // Maximum
      const MaxOverduePaymentsAmount = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsAmount?.value ?? ''
      const MaxOverduePaymentsNumber = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsNumber?.value ?? ''
      const MaxDaysPastDue = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxDaysPastDue?.value ?? ''
      const WorstStatusCode = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusCode?.value ?? ''
      const WorstStatusDesc = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDesc?.value ?? ''
      const WorstStatusDate = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDate?.value ?? ''
      // end Maximum

      // list profile
      const listProfileArr = Array.from(element.getElementsByTagName('cb:LetterOfCreditProfile')).map(subElement => {
        const ReferenceYear = subElement.attributes.ReferenceYear?.value ?? '';
        const ReferenceMonth = subElement.attributes.ReferenceMonth?.value ?? '';
        const DaysPastDue = subElement.attributes.DaysPastDue?.value ?? '';
        const Overdue = subElement.attributes.Overdue?.value ?? '';
        const OverduePaymentsNumber = subElement.attributes.OverduePaymentsNumber?.value ?? '';
        const QualityCode = subElement.attributes.QualityCode?.value ?? '';
        const QualityCodeDesc = subElement.attributes.QualityCodeDesc?.value ?? '';
        const BadCreditCauseCode = subElement.attributes.BadCreditCauseCode?.value ?? '';
        const BadCreditCauseDesc = subElement.attributes.BadCreditCauseDesc?.value ?? '';
        const DebitBalance = subElement.attributes.DebitBalance?.value ?? '';
        const CurrentMonthRealization = subElement.attributes.CurrentMonthRealization?.value ?? '';
        const ContractStatusCode = subElement.attributes.ContractStatusCode?.value ?? '';
        const ContractStatusDesc = subElement.attributes.ContractStatusDesc?.value ?? '';

        return { ReferenceYear, ReferenceMonth, DaysPastDue, Overdue, OverduePaymentsNumber, QualityCode, QualityCodeDesc, BadCreditCauseCode, BadCreditCauseDesc, DebitBalance, CurrentMonthRealization, ContractStatusCode, ContractStatusDesc }
      })
      let listProfile = [{ JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: null }];
      let tahun = null;
      const arrReverse = listProfileArr.reverse();
      console.log(arrReverse);
      arrReverse.forEach(e => {
        if (tahun !== null && tahun !== e.ReferenceYear) {
          listProfile = [...listProfile, { JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: e.ReferenceYear }]

          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        } else {
          listProfile[listProfile.length - 1].YEAR = e.ReferenceYear
          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        }

        tahun = e.ReferenceYear;

      })
      // end list profile 

      return {
        ReferenceNo,
        CBContractCode,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ReferenceDate,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ContractTypeCode,
        ContractTypeCodeDesc,
        StartDate,
        DueDate,
        CurrencyCode,
        CurrencyCodeDesc,
        PastDueStausCode,
        PastDueStausDesc,
        ContractStatusCode,
        ContractStatusDesc,
        ContractStatusDate,
        CodeCharacteristicCredit,
        CodeCharacteristicCreditDesc,
        CodeAgreementCredit,
        CodeAgreementCreditDesc,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        FinalAgreementNumber,
        FinalAgreementDate,
        FrequencyOfCredit,
        StartDateOfCredit,
        DebtorCategoryCode,
        DebtorCategoryCodeDesc,
        UsageTypeCode,
        UsageTypeCodeDesc,
        UsageOrientationCode,
        UsageOrientationCodeDesc,
        EconomicSectorCode,
        EconomicSectorCodeDesc,
        CityCode,
        CityCodeDesc,
        ProjectValue,
        InterestRate,
        TypeOfInterestRate,
        TypeOfInterestRateDesc,
        FinancigProgram,
        FinancigProgramDesc,
        InitialCreditLimit,
        CreditLimit,
        CurrentMonthRealization,
        Penalty,
        DebitBalance,
        ValueInOriginalCurrency,
        PrincipalOverdueAmount,
        InterestOverdueAmount,
        DaysPastDue,
        OverduePaymentsNumber,
        FrequencyOfRestructuring,
        BadCreditDate,
        BadCreditCauseCode,
        BadCreditCauseDesc,
        CollateralsCounter,
        TotalCollateralValue,
        GuarantorsCounter,
        GuarantorsData,
        MaxOverduePaymentsAmount,
        MaxOverduePaymentsNumber,
        MaxDaysPastDue,
        WorstStatusCode,
        WorstStatusDesc,
        WorstStatusDate,
        listProfile,
        listProfileArr: listProfileArr.reverse(),
      }
    })

    const result = {
      Name: "IRREVOCABLE LC",
      Requested,
      Active,
      Refused,
      Renounced,
      Closed,
      ContractsCounter,
      CreditLimit,
      DebitBalance,
      Overdue,
      NotGranted,
      Granted,
    }

    return result
  }

  const GuaranteeF = () => {
    // start section
    const GuaranteeRoot = root.getElementsByTagName('cb:Guarantee')[0]
    const NumbersSummary = GuaranteeRoot.getElementsByTagName('cb:NumbersSummary')[0]
    const Requested = NumbersSummary.attributes.Requested?.value ?? ''
    const Active = NumbersSummary.attributes.Active?.value ?? ''
    const Refused = NumbersSummary.attributes.Refused?.value ?? ''
    const Renounced = NumbersSummary.attributes.Renounced?.value ?? ''
    const Closed = NumbersSummary.attributes.Closed?.value ?? ''
    // end section

    // start section
    const AmountsSummary = GuaranteeRoot.getElementsByTagName('cb:AmountsSummary')[0]
    const ContractsCounter = AmountsSummary?.attributes?.ContractsCounter?.value ?? ''
    const CreditLimit = AmountsSummary?.attributes?.CreditLimit?.value ?? ''
    const DebitBalance = AmountsSummary?.attributes?.DebitBalance?.value ?? ''
    const Overdue = AmountsSummary?.attributes?.Overdue?.value ?? ''
    // end section

    // start section
    const NotGranted = Array.from(root.querySelectorAll("Guarantee > NotGrantedGuarantee")).map(element => {
      const CBContractCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CBContractCode?.value ?? '';
      const ProviderContractNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderContractNo?.value ?? '';
      const ContractType = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractType?.value ?? '';
      const ContractTypeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractTypeDesc?.value ?? '';
      const ContractPhase = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhase?.value ?? '';
      const ContractPhaseDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhaseDesc?.value ?? '';
      const Role = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.Role?.value ?? '';
      const RoleDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.RoleDesc?.value ?? '';
      const ProviderTypeCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCodeDesc?.value ?? '';
      const ContractRequestDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractRequestDate?.value ?? '';
      const DueDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.DueDate?.value ?? '';
      const CurrencyCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyCode.value ?? '';
      const CurrencyDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyDesc.value ?? '';
      const LastUpdateDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.LastUpdateDate.value ?? '';
      const ReferenceNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ReferenceNo.value ?? '';
      const ApplicationAmount = element.getElementsByTagName('cb:NotGrantedGuarantee')[0].attributes?.ApplicationAmount.value ?? '';
      const OriginalAgreementNumber = element.getElementsByTagName('cb:NotGrantedGuarantee')[0].attributes?.OriginalAgreementNumber?.value ?? '';
      const OriginalAgreementDate = element.getElementsByTagName('cb:NotGrantedGuarantee')[0].attributes?.OriginalAgreementDate?.value ?? '';
      const CBSubjectCode = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.CBSubjectCode?.value ?? ''
      const Name = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Name?.value ?? ''
      const RoleLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Role?.value ?? ''
      const RoleDescLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.RoleDesc?.value ?? ''

      return {
        CBContractCode,
        ProviderContractNo,
        ContractType,
        ContractTypeDesc,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ContractRequestDate,
        DueDate,
        CurrencyCode,
        CurrencyDesc,
        LastUpdateDate,
        ReferenceNo,
        ApplicationAmount,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        CBSubjectCode,
        Name,
        RoleLinkedSubject,
        RoleDescLinkedSubject,
      }
    })
    // end section

    const Granted = Array.from(root.querySelectorAll('Guarantee > GrantedGuarantee')).map(element => {

      // start CommonData
      const ReferenceNo = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceNo?.value ?? ''
      const CBContractCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CBContractCode?.value ?? ''
      const ProviderTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCode?.value ?? ''
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCodeDesc?.value ?? ''
      const ProviderCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCode?.value ?? ''
      const ProviderCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCodeDesc?.value ?? ''
      const ReferenceDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceDate?.value ?? ''
      const ContractPhase = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhase?.value ?? ''
      const ContractPhaseDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhaseDesc?.value ?? ''
      const Role = element.getElementsByTagName('cb:CommonData')[0].attributes?.Role?.value ?? ''
      const RoleDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.RoleDesc?.value ?? ''
      const ContractTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCode?.value ?? ''
      const ContractTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCodeDesc?.value ?? ''
      const StartDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.StartDate?.value ?? ''
      const DueDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.DueDate?.value ?? ''
      const CurrencyCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCode?.value ?? ''
      const CurrencyCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCodeDesc?.value ?? ''
      const PastDueStausCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausCode?.value ?? ''
      const PastDueStausDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausDesc?.value ?? ''
      const ContractStatusCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusCode?.value ?? ''
      const ContractStatusDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDesc?.value ?? ''
      const ContractStatusDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDate?.value ?? ''
      // end CommonData

      // start GrantedGuarantee
      const CodeCharacteristicCredit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CodeCharacteristicCredit?.value ?? ''
      const CodeCharacteristicCreditDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CodeCharacteristicCreditDesc?.value ?? ''
      const CodeAgreementCredit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CodeAgreementCredit?.value ?? ''
      const CodeAgreementCreditDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CodeAgreementCreditDesc?.value ?? ''
      const OriginalAgreementNumber = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.OriginalAgreementNumber?.value ?? ''
      const OriginalAgreementDate = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.OriginalAgreementDate?.value ?? ''
      const FinalAgreementNumber = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FinalAgreementNumber?.value ?? ''
      const FinalAgreementDate = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FinalAgreementDate?.value ?? ''
      const FrequencyOfCredit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FrequencyOfCredit?.value ?? ''
      const StartDateOfCredit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.StartDateOfCredit?.value ?? ''
      const DebtorCategoryCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.DebtorCategoryCode?.value ?? ''
      const DebtorCategoryCodeDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.DebtorCategoryCodeDesc?.value ?? ''
      const UsageTypeCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.UsageTypeCode?.value ?? ''
      const UsageTypeCodeDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.UsageTypeCodeDesc?.value ?? ''
      const UsageOrientationCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.UsageOrientationCode?.value ?? ''
      const UsageOrientationCodeDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.UsageOrientationCodeDesc?.value ?? ''
      const EconomicSectorCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.EconomicSectorCode?.value ?? ''
      const EconomicSectorCodeDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.EconomicSectorCodeDesc?.value ?? ''
      const CityCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CityCode?.value ?? ''
      const CityCodeDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CityCodeDesc?.value ?? ''
      const ProjectValue = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.ProjectValue?.value ?? ''
      const InterestRate = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.InterestRate?.value ?? ''
      const TypeOfInterestRate = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.TypeOfInterestRate?.value ?? ''
      const TypeOfInterestRateDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.TypeOfInterestRateDesc?.value ?? ''
      const FinancigProgram = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FinancigProgram?.value ?? ''
      const FinancigProgramDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FinancigProgramDesc?.value ?? ''
      const InitialCreditLimit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.InitialCreditLimit?.value ?? ''
      const CreditLimit = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CreditLimit?.value ?? ''
      const CurrentMonthRealization = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.CurrentMonthRealization?.value ?? ''
      const Penalty = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.Penalty?.value ?? ''
      const DebitBalance = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.DebitBalance?.value ?? ''
      const ValueInOriginalCurrency = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.ValueInOriginalCurrency?.value ?? ''
      const PrincipalOverdueAmount = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.PrincipalOverdueAmount?.value ?? ''
      const InterestOverdueAmount = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.InterestOverdueAmount?.value ?? ''
      const DaysPastDue = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.DaysPastDue?.value ?? ''
      const OverduePaymentsNumber = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.OverduePaymentsNumber?.value ?? ''
      const FrequencyOfRestructuring = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.FrequencyOfRestructuring?.value ?? ''
      const BadCreditDate = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.BadCreditDate?.value ?? ''
      const BadCreditCauseCode = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.BadCreditCauseCode?.value ?? ''
      const BadCreditCauseDesc = element.getElementsByTagName('cb:GrantedGuarantee')[0].attributes?.BadCreditCauseDesc?.value ?? ''
      // end GrantedGuarantee

      // Collaterals
      const CollateralsCounter = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.CollateralsCounter?.value ?? ''
      const TotalCollateralValue = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.TotalCollateralValue?.value ?? ''
      // End Collaterals

      // Guarantors
      const GuarantorsCounter = element.getElementsByTagName('cb:GuarantorsSummary')[0].attributes?.GuarantorsCounter?.value ?? ''
      const GuarantorsData = Array.from(element.getElementsByTagName('cb:GuarantorsData')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ReferenceDate?.value ?? ''
        // end AttributeData

        // GrantedGuarantor
        const GuarantorNameAsID = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorNameAsID?.value ?? ''
        const GuarantorFullName = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorFullName?.value ?? ''
        const GuarantorTypeCode = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeCode?.value ?? ''
        const GuarantorTypeDesc = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeDesc?.value ?? ''
        const PercentageGuaranteed = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.PercentageGuaranteed?.value ?? ''
        // end GrantedGuarantor

        // GuarantorAddress
        const Address = subElement.getElementsByTagName('cb:GuarantorAddress')[0].attributes.Address?.value ?? ''
        // end GuarantorAddress

        // GuarantorIdentity
        const IdentityType = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityType?.value ?? ''
        const IdentityNumber = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityNumber?.value ?? ''
        const IdentityTypeDesc = subElement.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes.IdentityTypeDesc?.value ?? ''
        // end GuarantorIdentity

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          GuarantorNameAsID,
          GuarantorFullName,
          GuarantorTypeCode,
          GuarantorTypeDesc,
          PercentageGuaranteed,
          Address,
          IdentityType,
          IdentityNumber,
          IdentityTypeDesc,
        }
      })
      // end Guarantors

      // Maximum
      const MaxOverduePaymentsAmount = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsAmount?.value ?? ''
      const MaxOverduePaymentsNumber = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsNumber?.value ?? ''
      const MaxDaysPastDue = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxDaysPastDue?.value ?? ''
      const WorstStatusCode = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusCode?.value ?? ''
      const WorstStatusDesc = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDesc?.value ?? ''
      const WorstStatusDate = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDate?.value ?? ''
      // end Maximum

      // list profile
      const listProfileArr = Array.from(element.getElementsByTagName('cb:GuaranteeProfile')).map(subElement => {
        const ReferenceYear = subElement.attributes.ReferenceYear?.value ?? '';
        const ReferenceMonth = subElement.attributes.ReferenceMonth?.value ?? '';
        const DaysPastDue = subElement.attributes.DaysPastDue?.value ?? '';
        const Overdue = subElement.attributes.Overdue?.value ?? '';
        const OverduePaymentsNumber = subElement.attributes.OverduePaymentsNumber?.value ?? '';
        const QualityCode = subElement.attributes.QualityCode?.value ?? '';
        const QualityCodeDesc = subElement.attributes.QualityCodeDesc?.value ?? '';
        const BadCreditCauseCode = subElement.attributes.BadCreditCauseCode?.value ?? '';
        const BadCreditCauseDesc = subElement.attributes.BadCreditCauseDesc?.value ?? '';
        const DebitBalance = subElement.attributes.DebitBalance?.value ?? '';
        const CurrentMonthRealization = subElement.attributes.CurrentMonthRealization?.value ?? '';
        const ContractStatusCode = subElement.attributes.ContractStatusCode?.value ?? '';
        const ContractStatusDesc = subElement.attributes.ContractStatusDesc?.value ?? '';

        return { ReferenceYear, ReferenceMonth, DaysPastDue, Overdue, OverduePaymentsNumber, QualityCode, QualityCodeDesc, BadCreditCauseCode, BadCreditCauseDesc, DebitBalance, CurrentMonthRealization, ContractStatusCode, ContractStatusDesc }
      })
      let listProfile = [{ JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: null }];
      let tahun = null;
      const arrReverse = listProfileArr.reverse();
      console.log(arrReverse);
      arrReverse.forEach(e => {
        if (tahun !== null && tahun !== e.ReferenceYear) {
          listProfile = [...listProfile, { JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: e.ReferenceYear }]

          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        } else {
          listProfile[listProfile.length - 1].YEAR = e.ReferenceYear
          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        }

        tahun = e.ReferenceYear;

      })
      // end list profile 

      return {
        ReferenceNo,
        CBContractCode,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ReferenceDate,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ContractTypeCode,
        ContractTypeCodeDesc,
        StartDate,
        DueDate,
        CurrencyCode,
        CurrencyCodeDesc,
        PastDueStausCode,
        PastDueStausDesc,
        ContractStatusCode,
        ContractStatusDesc,
        ContractStatusDate,
        CodeCharacteristicCredit,
        CodeCharacteristicCreditDesc,
        CodeAgreementCredit,
        CodeAgreementCreditDesc,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        FinalAgreementNumber,
        FinalAgreementDate,
        FrequencyOfCredit,
        StartDateOfCredit,
        DebtorCategoryCode,
        DebtorCategoryCodeDesc,
        UsageTypeCode,
        UsageTypeCodeDesc,
        UsageOrientationCode,
        UsageOrientationCodeDesc,
        EconomicSectorCode,
        EconomicSectorCodeDesc,
        CityCode,
        CityCodeDesc,
        ProjectValue,
        InterestRate,
        TypeOfInterestRate,
        TypeOfInterestRateDesc,
        FinancigProgram,
        FinancigProgramDesc,
        InitialCreditLimit,
        CreditLimit,
        CurrentMonthRealization,
        Penalty,
        DebitBalance,
        ValueInOriginalCurrency,
        PrincipalOverdueAmount,
        InterestOverdueAmount,
        DaysPastDue,
        OverduePaymentsNumber,
        FrequencyOfRestructuring,
        BadCreditDate,
        BadCreditCauseCode,
        BadCreditCauseDesc,
        CollateralsCounter,
        TotalCollateralValue,
        GuarantorsCounter,
        GuarantorsData,
        MaxOverduePaymentsAmount,
        MaxOverduePaymentsNumber,
        MaxDaysPastDue,
        WorstStatusCode,
        WorstStatusDesc,
        WorstStatusDate,
        listProfile,
        listProfileArr: listProfileArr.reverse(),
      }
    })

    const result = {
      Name: "BANK GUARANTEE",
      Requested,
      Active,
      Refused,
      Renounced,
      Closed,
      ContractsCounter,
      CreditLimit,
      DebitBalance,
      Overdue,
      NotGranted,
      Granted,
    }

    return result
  }

  const OtherFacilitiesF = () => {
    // start section
    const OtherFacilitiesRoot = root.getElementsByTagName('cb:OtherFacilities')[0]
    const NumbersSummary = OtherFacilitiesRoot.getElementsByTagName('cb:NumbersSummary')[0]
    const Requested = NumbersSummary.attributes.Requested?.value ?? ''
    const Active = NumbersSummary.attributes.Active?.value ?? ''
    const Refused = NumbersSummary.attributes.Refused?.value ?? ''
    const Renounced = NumbersSummary.attributes.Renounced?.value ?? ''
    const Closed = NumbersSummary.attributes.Closed?.value ?? ''
    // end section

    // start section
    const AmountsSummary = OtherFacilitiesRoot.getElementsByTagName('cb:AmountsSummary')[0]
    const ContractsCounter = AmountsSummary?.attributes?.ContractsCounter?.value ?? ''
    const CreditLimit = AmountsSummary?.attributes?.CreditLimit?.value ?? ''
    const DebitBalance = AmountsSummary?.attributes?.DebitBalance?.value ?? ''
    const Overdue = AmountsSummary?.attributes?.Overdue?.value ?? ''
    // end section

    // start section
    const NotGranted = Array.from(root.querySelectorAll("OtherFacilities > NotGrantedOtherFacilities")).map(element => {
      const CBContractCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CBContractCode?.value ?? '';
      const ProviderContractNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderContractNo?.value ?? '';
      const ContractType = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractType?.value ?? '';
      const ContractTypeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractTypeDesc?.value ?? '';
      const ContractPhase = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhase?.value ?? '';
      const ContractPhaseDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractPhaseDesc?.value ?? '';
      const Role = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.Role?.value ?? '';
      const RoleDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.RoleDesc?.value ?? '';
      const ProviderTypeCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCode?.value ?? '';
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderTypeCodeDesc?.value ?? '';
      const ProviderCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCode?.value ?? '';
      const ProviderCodeDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ProviderCodeDesc?.value ?? '';
      const ContractRequestDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ContractRequestDate?.value ?? '';
      const DueDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.DueDate?.value ?? '';
      const CurrencyCode = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyCode.value ?? '';
      const CurrencyDesc = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.CurrencyDesc.value ?? '';
      const LastUpdateDate = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.LastUpdateDate.value ?? '';
      const ReferenceNo = element.getElementsByTagName('cb:NotGrantedContract')[0].attributes?.ReferenceNo.value ?? '';
      const ApplicationAmount = element.getElementsByTagName('cb:NotGrantedOtherFacilities')[0].attributes?.ApplicationAmount.value ?? '';
      const OriginalAgreementNumber = element.getElementsByTagName('cb:NotGrantedOtherFacilities')[0].attributes?.OriginalAgreementNumber?.value ?? '';
      const OriginalAgreementDate = element.getElementsByTagName('cb:NotGrantedOtherFacilities')[0].attributes?.OriginalAgreementDate?.value ?? '';
      const CBSubjectCode = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.CBSubjectCode?.value ?? ''
      const Name = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Name?.value ?? ''
      const RoleLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.Role?.value ?? ''
      const RoleDescLinkedSubject = element.getElementsByTagName('cb:LinkedSubject')[0]?.attributes?.RoleDesc?.value ?? ''

      return {
        CBContractCode,
        ProviderContractNo,
        ContractType,
        ContractTypeDesc,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ContractRequestDate,
        DueDate,
        CurrencyCode,
        CurrencyDesc,
        LastUpdateDate,
        ReferenceNo,
        ApplicationAmount,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        CBSubjectCode,
        Name,
        RoleLinkedSubject,
        RoleDescLinkedSubject,
      }
    })
    // end section

    const Granted = Array.from(root.querySelectorAll('OtherFacilities > GrantedOtherFacilities')).map(element => {

      // start CommonData
      const ReferenceNo = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceNo?.value ?? ''
      const CBContractCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CBContractCode?.value ?? ''
      const ProviderTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCode?.value ?? ''
      const ProviderTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderTypeCodeDesc?.value ?? ''
      const ProviderCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCode?.value ?? ''
      const ProviderCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ProviderCodeDesc?.value ?? ''
      const ReferenceDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ReferenceDate?.value ?? ''
      const ContractPhase = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhase?.value ?? ''
      const ContractPhaseDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractPhaseDesc?.value ?? ''
      const Role = element.getElementsByTagName('cb:CommonData')[0].attributes?.Role?.value ?? ''
      const RoleDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.RoleDesc?.value ?? ''
      const ContractTypeCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCode?.value ?? ''
      const ContractTypeCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractTypeCodeDesc?.value ?? ''
      const StartDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.StartDate?.value ?? ''
      const DueDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.DueDate?.value ?? ''
      const CurrencyCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCode?.value ?? ''
      const CurrencyCodeDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.CurrencyCodeDesc?.value ?? ''
      const PastDueStausCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausCode?.value ?? ''
      const PastDueStausDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.PastDueStausDesc?.value ?? ''
      const ContractStatusCode = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusCode?.value ?? ''
      const ContractStatusDesc = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDesc?.value ?? ''
      const ContractStatusDate = element.getElementsByTagName('cb:CommonData')[0].attributes?.ContractStatusDate?.value ?? ''
      // end CommonData

      // start GrantedOF
      const CodeCharacteristicCredit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CodeCharacteristicCredit?.value ?? ''
      const CodeCharacteristicCreditDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CodeCharacteristicCreditDesc?.value ?? ''
      const CodeAgreementCredit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CodeAgreementCredit?.value ?? ''
      const CodeAgreementCreditDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CodeAgreementCreditDesc?.value ?? ''
      const OriginalAgreementNumber = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.OriginalAgreementNumber?.value ?? ''
      const OriginalAgreementDate = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.OriginalAgreementDate?.value ?? ''
      const FinalAgreementNumber = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FinalAgreementNumber?.value ?? ''
      const FinalAgreementDate = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FinalAgreementDate?.value ?? ''
      const FrequencyOfCredit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FrequencyOfCredit?.value ?? ''
      const StartDateOfCredit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.StartDateOfCredit?.value ?? ''
      const DebtorCategoryCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.DebtorCategoryCode?.value ?? ''
      const DebtorCategoryCodeDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.DebtorCategoryCodeDesc?.value ?? ''
      const UsageTypeCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.UsageTypeCode?.value ?? ''
      const UsageTypeCodeDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.UsageTypeCodeDesc?.value ?? ''
      const UsageOrientationCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.UsageOrientationCode?.value ?? ''
      const UsageOrientationCodeDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.UsageOrientationCodeDesc?.value ?? ''
      const EconomicSectorCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.EconomicSectorCode?.value ?? ''
      const EconomicSectorCodeDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.EconomicSectorCodeDesc?.value ?? ''
      const CityCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CityCode?.value ?? ''
      const CityCodeDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CityCodeDesc?.value ?? ''
      const ProjectValue = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.ProjectValue?.value ?? ''
      const InterestRate = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.InterestRate?.value ?? ''
      const TypeOfInterestRate = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.TypeOfInterestRate?.value ?? ''
      const TypeOfInterestRateDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.TypeOfInterestRateDesc?.value ?? ''
      const FinancigProgram = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FinancigProgram?.value ?? ''
      const FinancigProgramDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FinancigProgramDesc?.value ?? ''
      const InitialCreditLimit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.InitialCreditLimit?.value ?? ''
      const CreditLimit = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CreditLimit?.value ?? ''
      const CurrentMonthRealization = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.CurrentMonthRealization?.value ?? ''
      const Penalty = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.Penalty?.value ?? ''
      const DebitBalance = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.DebitBalance?.value ?? ''
      const ValueInOriginalCurrency = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.ValueInOriginalCurrency?.value ?? ''
      const PrincipalOverdueAmount = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.PrincipalOverdueAmount?.value ?? ''
      const InterestOverdueAmount = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.InterestOverdueAmount?.value ?? ''
      const DaysPastDue = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.DaysPastDue?.value ?? ''
      const OverduePaymentsNumber = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.OverduePaymentsNumber?.value ?? ''
      const FrequencyOfRestructuring = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.FrequencyOfRestructuring?.value ?? ''
      const BadCreditDate = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.BadCreditDate?.value ?? ''
      const BadCreditCauseCode = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.BadCreditCauseCode?.value ?? ''
      const BadCreditCauseDesc = element.getElementsByTagName('cb:GrantedOF')[0].attributes?.BadCreditCauseDesc?.value ?? ''
      // end GrantedOF

      // Collaterals
      const CollateralsCounter = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.CollateralsCounter?.value ?? ''
      const TotalCollateralValue = element.getElementsByTagName('cb:CollateralsSummary')[0].attributes?.TotalCollateralValue?.value ?? ''
      // End Collaterals

      // Guarantors
      const GuarantorsCounter = element.getElementsByTagName('cb:GuarantorsSummary')[0].attributes?.GuarantorsCounter?.value ?? ''
      const GuarantorsData = Array.from(element.getElementsByTagName('cb:GuarantorsData')).map(subElement => {
        // AttributeData
        const ProviderTypeCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCode?.value ?? ''
        const ProviderTypeCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderTypeCodeDesc?.value ?? ''
        const ProviderCode = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCode?.value ?? ''
        const ProviderCodeDesc = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ProviderCodeDesc?.value ?? ''
        const ReferenceDate = subElement.getElementsByTagName('cb:AttributeData')[0].attributes.ReferenceDate?.value ?? ''
        // end AttributeData

        // GrantedGuarantor
        const GuarantorNameAsID = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorNameAsID?.value ?? ''
        const GuarantorFullName = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorFullName?.value ?? ''
        const GuarantorTypeCode = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeCode?.value ?? ''
        const GuarantorTypeDesc = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.GuarantorTypeDesc?.value ?? ''
        const PercentageGuaranteed = subElement.getElementsByTagName('cb:GrantedGuarantor')[0].attributes.PercentageGuaranteed?.value ?? ''
        // end GrantedGuarantor

        // GuarantorAddress
        const Address = subElement.getElementsByTagName('cb:GuarantorAddress')[0].attributes.Address?.value ?? ''
        // end GuarantorAddress

        // GuarantorIdentity
        const IdentityType = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityType?.value ?? ''
        const IdentityNumber = subElement.getElementsByTagName('cb:IdentificationCode')[0].attributes.IdentityNumber?.value ?? ''
        const IdentityTypeDesc = subElement.getElementsByTagName('cb:IdentificationCodeDesc')[0].attributes.IdentityTypeDesc?.value ?? ''
        // end GuarantorIdentity

        return {
          ProviderTypeCode,
          ProviderTypeCodeDesc,
          ProviderCode,
          ProviderCodeDesc,
          ReferenceDate,
          GuarantorNameAsID,
          GuarantorFullName,
          GuarantorTypeCode,
          GuarantorTypeDesc,
          PercentageGuaranteed,
          Address,
          IdentityType,
          IdentityNumber,
          IdentityTypeDesc,
        }
      })
      // end Guarantors

      // Maximum
      const MaxOverduePaymentsAmount = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsAmount?.value ?? ''
      const MaxOverduePaymentsNumber = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxOverduePaymentsNumber?.value ?? ''
      const MaxDaysPastDue = element.getElementsByTagName('cb:Maximum')[0].attributes?.MaxDaysPastDue?.value ?? ''
      const WorstStatusCode = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusCode?.value ?? ''
      const WorstStatusDesc = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDesc?.value ?? ''
      const WorstStatusDate = element.getElementsByTagName('cb:Maximum')[0].attributes?.WorstStatusDate?.value ?? ''
      // end Maximum

      // list profile
      const listProfileArr = Array.from(element.getElementsByTagName('cb:OFProfile')).map(subElement => {
        const ReferenceYear = subElement.attributes.ReferenceYear?.value ?? '';
        const ReferenceMonth = subElement.attributes.ReferenceMonth?.value ?? '';
        const DaysPastDue = subElement.attributes.DaysPastDue?.value ?? '';
        const Overdue = subElement.attributes.Overdue?.value ?? '';
        const OverduePaymentsNumber = subElement.attributes.OverduePaymentsNumber?.value ?? '';
        const QualityCode = subElement.attributes.QualityCode?.value ?? '';
        const QualityCodeDesc = subElement.attributes.QualityCodeDesc?.value ?? '';
        const BadCreditCauseCode = subElement.attributes.BadCreditCauseCode?.value ?? '';
        const BadCreditCauseDesc = subElement.attributes.BadCreditCauseDesc?.value ?? '';
        const DebitBalance = subElement.attributes.DebitBalance?.value ?? '';
        const CurrentMonthRealization = subElement.attributes.CurrentMonthRealization?.value ?? '';
        const ContractStatusCode = subElement.attributes.ContractStatusCode?.value ?? '';
        const ContractStatusDesc = subElement.attributes.ContractStatusDesc?.value ?? '';

        return { ReferenceYear, ReferenceMonth, DaysPastDue, Overdue, OverduePaymentsNumber, QualityCode, QualityCodeDesc, BadCreditCauseCode, BadCreditCauseDesc, DebitBalance, CurrentMonthRealization, ContractStatusCode, ContractStatusDesc }
      })
      let listProfile = [{ JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: null }];
      let tahun = null;
      const arrReverse = listProfileArr.reverse();
      console.log(arrReverse);
      arrReverse.forEach(e => {
        if (tahun !== null && tahun !== e.ReferenceYear) {
          listProfile = [...listProfile, { JAN: null, FEB: null, MAR: null, APR: null, MEI: null, JUN: null, JUL: null, AUG: null, SEP: null, OCT: null, NOV: null, DEC: null, YEAR: e.ReferenceYear }]

          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        } else {
          listProfile[listProfile.length - 1].YEAR = e.ReferenceYear
          if (e.ReferenceMonth == 1) {
            listProfile[listProfile.length - 1].JAN = e
          } else if (e.ReferenceMonth == 2) {
            listProfile[listProfile.length - 1].FEB = e
          } else if (e.ReferenceMonth == 3) {
            listProfile[listProfile.length - 1].MAR = e
          } else if (e.ReferenceMonth == 4) {
            listProfile[listProfile.length - 1].APR = e
          } else if (e.ReferenceMonth == 5) {
            listProfile[listProfile.length - 1].MEI = e
          } else if (e.ReferenceMonth == 6) {
            listProfile[listProfile.length - 1].JUN = e
          } else if (e.ReferenceMonth == 7) {
            listProfile[listProfile.length - 1].JUL = e
          } else if (e.ReferenceMonth == 8) {
            listProfile[listProfile.length - 1].AUG = e
          } else if (e.ReferenceMonth == 9) {
            listProfile[listProfile.length - 1].SEP = e
          } else if (e.ReferenceMonth == 10) {
            listProfile[listProfile.length - 1].OCT = e
          } else if (e.ReferenceMonth == 11) {
            listProfile[listProfile.length - 1].NOV = e
          } else if (e.ReferenceMonth == 12) {
            listProfile[listProfile.length - 1].DEC = e
          }
        }

        tahun = e.ReferenceYear;

      })
      // end list profile 

      return {
        ReferenceNo,
        CBContractCode,
        ProviderTypeCode,
        ProviderTypeCodeDesc,
        ProviderCode,
        ProviderCodeDesc,
        ReferenceDate,
        ContractPhase,
        ContractPhaseDesc,
        Role,
        RoleDesc,
        ContractTypeCode,
        ContractTypeCodeDesc,
        StartDate,
        DueDate,
        CurrencyCode,
        CurrencyCodeDesc,
        PastDueStausCode,
        PastDueStausDesc,
        ContractStatusCode,
        ContractStatusDesc,
        ContractStatusDate,
        CodeCharacteristicCredit,
        CodeCharacteristicCreditDesc,
        CodeAgreementCredit,
        CodeAgreementCreditDesc,
        OriginalAgreementNumber,
        OriginalAgreementDate,
        FinalAgreementNumber,
        FinalAgreementDate,
        FrequencyOfCredit,
        StartDateOfCredit,
        DebtorCategoryCode,
        DebtorCategoryCodeDesc,
        UsageTypeCode,
        UsageTypeCodeDesc,
        UsageOrientationCode,
        UsageOrientationCodeDesc,
        EconomicSectorCode,
        EconomicSectorCodeDesc,
        CityCode,
        CityCodeDesc,
        ProjectValue,
        InterestRate,
        TypeOfInterestRate,
        TypeOfInterestRateDesc,
        FinancigProgram,
        FinancigProgramDesc,
        InitialCreditLimit,
        CreditLimit,
        CurrentMonthRealization,
        Penalty,
        DebitBalance,
        ValueInOriginalCurrency,
        PrincipalOverdueAmount,
        InterestOverdueAmount,
        DaysPastDue,
        OverduePaymentsNumber,
        FrequencyOfRestructuring,
        BadCreditDate,
        BadCreditCauseCode,
        BadCreditCauseDesc,
        CollateralsCounter,
        TotalCollateralValue,
        GuarantorsCounter,
        GuarantorsData,
        MaxOverduePaymentsAmount,
        MaxOverduePaymentsNumber,
        MaxDaysPastDue,
        WorstStatusCode,
        WorstStatusDesc,
        WorstStatusDate,
        listProfile,
        listProfileArr: listProfileArr.reverse(),
      }
    })

    const result = {
      Name: "OTHER FACILITIES",
      Requested,
      Active,
      Refused,
      Renounced,
      Closed,
      ContractsCounter,
      CreditLimit,
      DebitBalance,
      Overdue,
      NotGranted,
      Granted,
    }

    return result
  }

  const Credit = CreditF();
  const Bond = BondF();
  const LetterOfCredit = LetterOfCreditF();
  const Guarantee = GuaranteeF();
  const OtherFacilities = OtherFacilitiesF();

  const result = {
    ContractsNumber,
    ReportingProvidersNumber,
    TotalCreditLimit,
    TotalPotentialExposure,
    TotalDebitBalance,
    TotalOverdue,
    Currency,
    CurrencyDesc,
    ContractCategory: [Credit, Bond, LetterOfCredit, Guarantee, OtherFacilities]
  }
  return result;
}

export default contractsHistory;